import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Cta = ({ title, subtitle }) => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data);
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="h-[40vh] flex items-center justify-center bg-[#000929]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#d90845]"></div>
      </div>
    );
  }

  return (
    <div className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.vecteezy.com/system/resources/previews/008/680/961/non_2x/abstract-technology-background-free-vector.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#000929]/85 backdrop-blur-sm"></div>
      </div>

      {/* Content Container */}
      <div className="container mx-auto px-4 relative z-10 text-center mt-28">
        <div className="max-w-4xl mx-auto space-y-4 animate-fadeInUp">
          {/* Dynamic Title */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white px-4 py-2 bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 inline-block shadow-2xl">
            {title}
          </h1>
        </div>
      </div>

      {/* Bottom Shape Overlay */}
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
    </div>
  );
};

export default Cta;
